import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { chemistmasterdata } from '../../model';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-chemistaddtionalapproval',
  template: require('./chemistaddtionalapproval.component.html'),
  styles: []
})
export class ChemistAddtionalApprovalComponent implements OnInit {

  expDetails: any;
  columnApi: ColumnApi;
  private columnDefs;
  private rowData: any[];
  private rowHeight;
  api: GridApi;
  busy: Subscription;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;
  rowSelectionMultiple: string;
  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;
  chemistmasterdataModel: chemistmasterdata = new chemistmasterdata();
  headQuarterList: any = [];
  stateList: any = [];
  empData: any = [];
  static parameters = [ApiService]
  EmployeeId: any = [];
  token:any;
  constructor(
    private apiService: ApiService

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      { headerName: '', field: 'action', width: 150, checkboxSelection: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true },
      {
        headerName: 'Employee Code', field: "EmployeeCode", filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Employee Name', field: "EmployeeName", filter: 'agTextColumnFilter'
      },
      { headerName: 'Date', field: "AddedOn", filter: 'agTextColumnFilter' },
      { headerName: 'Chemist Name ', field: "ChemistName", filter: 'agTextColumnFilter' },
      { headerName: 'Area', field: "AreaName", filter: 'agTextColumnFilter' },
      { headerName: 'Mobile Number', field: "Phone", filter: 'agTextColumnFilter' },
      { headerName: 'Visit Frequency ', field: "VisitFrequency", filter: 'agTextColumnFilter' },
      { headerName: 'Customer Category ', field: "ChemistCategory", filter: 'agTextColumnFilter' },
      { headerName: 'Route  ', field: "RouteName", filter: 'agTextColumnFilter' },
    ];
    this.defaultColDefine = { resizable: true };
    this.rowHeight = 50;
  }

  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.rowSelectionMultiple = 'multiple';
    this.chemistmasterdataModel.Client_Code = '0';
    this.chemistmasterdataModel.Category = '0';
    this.chemistmasterdataModel.HQ = '0';
    this.chemistmasterdataModel.StateID = 0;
    this.getEmployee();
    this.getState();
    this.getHeadQuarterList();
    $('#filter-option').trigger('click');

  }


  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();
  }

  onBtnExport() {
    this.api.exportDataAsCsv({ fileName: 'chemeistadditionalapproval' });
  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }
  getEmployee() {
    var data = {
      Id: this.token.id
  };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.empData = res.data;
    })
  }

  getState() {
    this.apiService.getState().subscribe((res: any) => {
      this.stateList = res.data;
    })
  }

  getHeadQuarterList() {
    this.apiService.getHeadQuarterList().subscribe((res: any) => {
      this.headQuarterList = res.data;
    })
  }

  approve(type: any) {
    var SelectedData = [];
    SelectedData = this.api.getSelectedRows();
    if (SelectedData.length == 0) {
      alert(`Please Select Employee Chemist For ` + (type == 1 ? `Approval` : `Reject`));
      return false;
    }
    var id = SelectedData.map(item => item._ID).toString();
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    console.log('token', token);
    var data = { id: id, approvedBy: token.id, ApproveType: type };
    this.busy = this.apiService.ApproveRejectEmployeeChemist(data).subscribe((res: any) => {
      alert("Employee Chemist " + (type == 1 ? `Approved` : `Rejected`) + " Successfully");
      this.GetDCRUnlockListForApproval();
    })
  }

  GetDCRUnlockListForApproval() {
   // console.log(this.chemistmasterdataModel);
    var queryData = {
      LoginId: this.token.id,
      Category: this.chemistmasterdataModel.Category,
      Client_Code: this.chemistmasterdataModel.Client_Code,
      HQ: this.chemistmasterdataModel.HQ,
      StateID: this.chemistmasterdataModel.StateID
    }

    this.busy = this.apiService.GetChemistAdditionApprovalList(queryData).subscribe((res: any) => {
      this.rowData = res;
      // console.log('this.rowData', this.rowData);
      // this.getChemistForReset();
    })


  }
}
